import { render, staticRenderFns } from "./LocalPagination.vue?vue&type=template&id=32c3491c&"
import script from "./LocalPagination.vue?vue&type=script&lang=js&"
export * from "./LocalPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports